'use client';

import { useTranslations } from 'next-intl';
import type { StepProps } from './stepProps';
import { StepShell } from './StepShell';
import { FormTextarea } from '@/components/form/FormTextarea';

/** Step 5 — Nachricht (AC 6). Optional, so the step is always advanceable. */
export const Step5Message = ({
  state,
  dispatch,
  chrome,
  onBack,
  onNext,
}: StepProps) => {
  const t = useTranslations('tutorApplication');

  return (
    <StepShell
      heading={t('step5Heading')}
      chrome={chrome}
      onBack={onBack}
      onNext={onNext}
    >
      <FormTextarea
        label={t('messageLabel')}
        placeholder={t('messagePlaceholder')}
        value={state.message}
        onChange={(e) =>
          dispatch({ type: 'UPDATE_MESSAGE', message: e.target.value })
        }
      />
    </StepShell>
  );
};
